module.exports = __webpack_public_path__ + "static/media/cancel-gray.97fc27f0.svg";